<template>
  <div>
    <page-header></page-header>
    <section class="section is-paddingless">
      <div class="container pricing">
        <h1 class="title is-1 custom-h1">Pricing</h1>
        <h5 class="title is-3 custom-h5 has-text-weight-normal">Conciergo helps you run your front desk operations easily and efficiently. Our à la carte and bundle plans let’s you decide what your hotel’s needs are while saving money!</h5>
        <br>
        <div class="pricing-info">
          <div class="columns">
            <div class="column">
              <div class="pricing-table">
                <div class="has-text-centered" style="border-bottom: 1px solid #c3c0c0; padding: 30px;">
                  <h5 class="title is-3 has-text-weight-bold">à la carte</h5>
                </div>
                <div class="c-card">
                  <div class="columns" style="margin-bottom: 0px; margin-top: 0px;">
                    <div class="column is-half has-text-centered feature-div">
                      <div class="feature">
                        <h5 class="title is-5 has-text-weight-normal">Premium Splash Page</h5>
                        <div class="for-mobile-only">
                          <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">$3.00</h5>
                          <p>Per Room</p>
                          <p>Per Month</p>
                        </div>
                      </div>
                      <div class="feature">
                        <h5 class="title is-5 has-text-weight-normal">SMS Software</h5>
                        <div class="for-mobile-only">
                          <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">$3.00</h5>
                          <p>Per Room</p>
                          <p>Per Month</p>
                        </div>
                      </div>
                      <div class="feature">
                        <h5 class="title is-5 has-text-weight-normal">Keycard Holders</h5>
                        <div class="for-mobile-only">
                          <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">$0.05</h5>
                          <p>Per Sleeve</p>
                          <p>3-Month Minimum</p>
                        </div>
                      </div>
                    </div>
                    <div class="column is-half has-text-centered" style="padding: 40px;" id="price">
                      <div class="price">
                        <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">$3.00</h5>
                        <p>Per Room</p>
                        <p>Per Month</p>
                      </div>
                      <div class="price">
                        <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">$3.00</h5>
                        <p>Per Room</p>
                        <p>Per Month</p>
                      </div>
                      <div class="price">
                        <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">$0.05</h5>
                        <p>Per Sleeve</p>
                        <p>3-Month Minimum</p>
                      </div>
                    </div>
                  </div>
                  <div class="columns setup-div">
                    <div class="column is-half has-text-centered setup">
                      <div class="feature">
                        <h5 class="title is-5 has-text-weight-bold mb-remove">Setup</h5>
                        <p>(one time fee)</p>
                      </div>
                    </div>
                    <div class="column is-half has-text-centered setup-price">
                      <div class="price">
                        <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">$199.99</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="has-text-centered" style="margin-top: -30px;">
                <button class="button is-danger is-large">SIGN UP</button>
              </div>
            </div>
            <div class="column">
              <div class="pricing-table">
                <div class="has-text-centered" style="border-bottom: 1px solid #c3c0c0; padding: 30px 30px 7px 30px;">
                  <h5 class="title is-3 has-text-weight-bold mb-remove">bundle</h5>
                  <p class="has-text-danger">(save)</p>
                </div>
                <div class="c-card">
                  <div class="columns" style="margin-bottom: 0px; margin-top: 0px;">
                    <div class="column is-half has-text-centered feature-div">
                      <div class="feature">
                        <h5 class="title is-5 has-text-weight-normal">Premium Splash Page</h5>
                      </div>
                      <div class="feature">
                        <h5 class="title is-5 has-text-weight-normal">SMS Software</h5>
                      </div>
                      <div class="feature">
                        <h5 class="title is-5 has-text-weight-normal">Keycard Holders</h5>
                      </div>
                    </div>
                    <div class="column is-half has-text-centered" style="padding: 40px;">
                      <div class="price for-desktop-only">
                        <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">&nbsp;</h5>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                      </div>
                      <div class="price">
                        <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">$3.00</h5>
                        <p>Per Room</p>
                        <p>Per Month</p>
                      </div>
                      <div class="price for-desktop-only">
                        <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">&nbsp;</h5>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                      </div>
                    </div>
                  </div>
                  <div class="columns setup-div">
                    <div class="column is-half has-text-centered setup">
                      <div class="feature">
                        <h5 class="title is-5 has-text-weight-bold mb-remove">Setup</h5>
                        <p>(one time fee)</p>
                      </div>
                    </div>
                    <div class="column is-half has-text-centered setup-price">
                      <div class="price">
                        <h5 class="title is-4 has-text-weight-bold" style="margin-bottom: 0px;">$199.99</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="has-text-centered" style="margin-top: -30px;">
                <button class="button is-danger is-large">SIGN UP</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section" style="background: #f1f1f1; margin-top: 60px;">
      <div class="container faq">
        <h1 class="title custom-h1">Frequently Asked Questions</h1>

        <div class="panel" v-for="(f, index) in faq" :key="index">
          <b-collapse :open='false' class="is-paddingless">
            <div class="field is-paddingless" slot-scope="props" slot='trigger'>
              <div class="control has-icons-right is-paddingless">
                <span class='title is-5 has-text-weight-bold'>
                  {{ f.question }}
                </span>
                <b-icon pack='fas' size='is-small' :icon="props.open ? 'minus' : 'plus'" class='is-right faq-icon' custom-class="has-text-black"> </b-icon>
              </div>
            </div>
            <h3 class="is-2 has-text-weight-normal answer" :class="'faq-' + index" v-html='f.answer'></h3>
          </b-collapse>
          <br />
        </div>

      </div>
    </section>
    <page-footer></page-footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
        isOpen: true,
        faq: [
          {question: 'How does Conciergo work?', answer:'Conciergo is a Guest Engagement System delivered directly to your guests from your hotel WiFi. Guest’s can access their digital concierge and communicate with your front desk staff using their mobile device. Check out our <a href="https://conciergo.com/_/upload/mediakit/how-it-works.pdf" target="_blank">How It Works</a> for more details.' },
          {question: 'How long does it take to setup?', answer:'We can have you set up in as little as 72 Hours! Once we receive your inquiry, a Conciergo representative will reach out to you and begin the onboarding process.' },
          {question: 'Will my PMS integrate with Conciergo?', answer:'Conciergo works with many PMS companies. Get in touch with one of our representatives to see if we work with yours.' },
          {question: 'Do I pay monthly or annually?', answer:'At Conciergo, we work with you in finding the best plan for you. We currently offer both options for your convenience. Get in touch with one of our representatives to find the best solution for your hotel.' },
          {question: 'What are the cancellation policies?', answer:'If you would like to cancel your service, we ask you to provide a 30-day notice in advance to be submitted to <a href="mailto:info@conciergo.com">info@conciergo.com</a> to provide sufficient processing time.' },
        ]
    }
  }
}
</script>
<style scoped lang="scss">
.feature-div {
  border-right: 1px solid #c3c0c0; padding: 60px 40px 0 40px;
}
.answer {
  margin-top: 10px;
  margin-bottom: 20px;
}
.pricing-table {
  background: #f1f1f1;
  border-radius: 10px;
}
.feature {
  margin-bottom: 50px;
  p {
    font-size: 12px;
  }
}
.price {
  margin-bottom: 40px;
  p {
    font-size: 12px;
  }
}
.mb-remove {
  margin-bottom: 0px !important;
}
.panel {
  margin-bottom: 0px !important;
  .title {
    cursor: pointer;
  }
}
.pricing-info {
  padding: 0 120px 0 120px;
}
.setup {
  border-right: 1px solid #c3c0c0; padding: 50px 0 0 0;
}
.setup-price {
  padding: 50px 0 0 0;
}
.setup-div {
  border-top: 1px solid #c3c0c0; margin: 0px;
}
.for-mobile-only {
  display: none;
}
.pricing {
  margin-top: 30px;
}
@media only screen and (max-width: 425px) {
  .faq-icon {
    display: none;
  }
  .setup-div {
    padding-bottom: 20px;
    padding-top: 20px;
  }
  .pricing {
    padding: 30px;
    h1 {
      font-size: 35px !important;
    }
    h5 {
      font-size: 20px !important;
    }
  }
  #price {
    display: none;
  }
  .pricing-info {
    padding: 0px;
    .column {
      border: none;
    }
  }
  .setup {
    border-right: none;
    padding-top: 10px;
    .feature {
      margin-bottom: 10px;
    }
  }
  .setup-price {
    padding-top: 0px !important;
  }
  .for-mobile-only {
    display: inline;
  }
  .for-desktop-only {
    display: none;
  }
  .faq {
    padding: 30px;
    .custom-h1 {
      font-size: 25px;
    }
    .panel {
      div {
        padding: 5px;
      }
      h5 {
        font-size: 20px;
        margin-top: 0px;
      }
      .fa {
        display: none;
      }
      .columns {
        margin-bottom: 0px;
      }
    }
  }
}
</style>
